import { SecurityMenu } from "./SecurityMenu";

export default SecurityMenu;
